// From Kendo Documentation:
// https://www.telerik.com/kendo-react-ui/components/grid/filtering/advanced-filtering#filtering-data-grid-through-custom-filter-cells

import { type SyntheticEvent } from 'react';
import {
    type GridFilterCellProps,
    type GridCustomFilterCellProps
} from '@progress/kendo-react-grid';
import { 
    DropDownList, 
    type DropDownListChangeEvent 
} from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { filterClearIcon } from '@progress/kendo-svg-icons';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';

export default function CategoryFilterCell(
    props: GridCustomFilterCellProps, 
    categories: string[]
) {
    return (
        <HeaderTdElement columnId={props.thProps?.columnId || ''} {...props.thProps}>
            <DropdownFilterCell 
                {...props} 
                data={categories} 
                // data={['foo','bar']} 
                defaultItem={'Select category'} 
            />
        </HeaderTdElement>
    )
};

interface DropdownFilterCellProps extends GridFilterCellProps {
    defaultItem: string;
    data: string[];
}

// function hasValueFn<T>(value: T, props: DropdownFilterCellProps): boolean { return Boolean(value && value !== props.defaultItem) };

const DropdownFilterCell = (props: DropdownFilterCellProps) => {
    const hasValueFn = (value: string) => Boolean(value && value !== props.defaultItem);

    const onChange = (event: DropDownListChangeEvent) => {
        const value: string = event.target.value as string;
        const hasValue = hasValueFn(value);
        props.onChange({
            value: hasValue ? value : '',
            operator: hasValue ? 'eq' : '',
            syntheticEvent: event.syntheticEvent
        });
    };

    const onClearButtonClick = (event: SyntheticEvent) => {
        event.preventDefault();
        props.onChange({
            value: '',
            operator: '',
            syntheticEvent: event
        });
    };

    return (
        <div className="k-filtercell">
            <div className="k-filtercell-wrapper">
                <DropDownList
                    data={props.data}
                    onChange={onChange}
                    value={props.value as string || props.defaultItem}
                    fillMode={'outline'}
                    defaultItem={props.defaultItem}
                />
                <Button
                    title="Clear"
                    disabled={!hasValueFn(props.value as string)}
                    onClick={onClearButtonClick}
                    svgIcon={filterClearIcon}
                />
            </div>
        </div>
    );
};